import { Field, Int, ObjectType } from '@nestjs/graphql'

@ObjectType()
export class AdminMonthlySubscriptionUsersDto {
  @Field()
  plan!: string

  @Field(t => [Int])
  durationCounts!: number[]
}

